
const getUserInfo=() => {
    return typeof window !== 'undefined'
        ? localStorage.getItem('USER_INFO') !== null
            ? { ...JSON.parse(localStorage.getItem('USER_INFO')) }
            : null
        : null
}

const  userInfo  = getUserInfo()
const CryptoJS = require("crypto-js");
function encrypt(data) {
    if (data) {
        data = CryptoJS.SHA256(data);
        data = data.toString();
        return data;
    } else {
        return undefined
    }
}

const encryptUserInfo = () => {
    // const userSession =  new userSessionStorage()
    // const userInfo = userSession.getUserInfo()
    let name, lastName, cellPhone, email, city, countryState, log_status
    if (userInfo) {
        name = userInfo.name || '';
        lastName = userInfo.lastName || '';
        cellPhone = userInfo.cellPhone || '';
        email = userInfo.email || '';
        city = userInfo.location?.cityName || '';
        countryState = userInfo.location?.countryStateName || '';


        const user_data = [{
            name: encrypt(name),
            lastName: encrypt(lastName),
            cellPhone: encrypt(cellPhone),
            email: encrypt(email),
            city: encrypt(city),
            countryState: encrypt(countryState),
        }]
        log_status = 'Yes'
        return { user_data, log_status }

    } else {
        log_status = 'No';
        return { log_status }
    }
}

export { encryptUserInfo }
